/** Touch play needs landscape: in portrait this card covers everything (CSS `portrait:` shows it). */
export function RotateCard() {
  return (
    <div role="alert" data-rotate-card className="absolute inset-0 hidden place-items-center bg-ink/85 p-6 text-center text-white portrait:grid">
      <div className="flex flex-col items-center gap-3">
        <span aria-hidden className="text-6xl">
          ⟳
        </span>
        <span className="text-2xl font-black uppercase italic">Turn your phone sideways</span>
        <span className="text-sm font-bold">Kickflip plays in landscape: left thumb steers, right thumb does tricks.</span>
      </div>
    </div>
  );
}
